import React, { useContext } from 'react';
import styled from 'styled-components';
import { useMutation, useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import TextWithIcon from '@components/TextWithIcon';
import { GET_VIDEO_SETTINGS } from '@lib/apollo';
import { Trans } from '@lingui/react';
import SettingsModal from '@organisms/modals/SettingsModal';
import { UserContext } from '@lib/contexts/UserProvider';
import { videoSettingsModalOpenVar, videoSettingsVar } from '@lib/apollo';

const PATCH_USER = gql`
  mutation patchUser(
    $contentLanguages: [String]
    $excludeTerms: [String]
    $videoLevels: [String]
  ) {
    patchUser(
      contentLanguages: $contentLanguages
      excludeTerms: $excludeTerms
      videoLevels: $videoLevels
    ) {
      user {
        id
      }
    }
  }
`;

const Button = styled.button`
  flex-shrink: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.neutrals.black};
  font-weight: 600;
  border: none;
  background: none;
  cursor: pointer;
`;

const VideoSettings = () => {
  const [currentUser, { loading: loadingUserPreferences }] = useContext(
    UserContext
  );
  const { data: videoSettingsData, loading: loadingVideoSettings } = useQuery(
    GET_VIDEO_SETTINGS
  );
  const [patchUser, { loading: patchingUser }] = useMutation(PATCH_USER);

  React.useEffect(() => {
    // when preferences are loaded
    if (currentUser?.preferences) {
      let contentLanguages = currentUser?.preferences?.contentLanguages;
      if (!contentLanguages?.length) {
        contentLanguages = ['en', 'se', 'fi', 'no'];
      }
      const { excludeTerms, videoLevels } = currentUser.preferences;
      videoSettingsVar({
        excludeTerms,
        videoLevels,
        contentLanguages,
      });
    }
  }, [currentUser?.preferences]);

  const openSettingModal = () => {
    videoSettingsModalOpenVar(true);
  };

  if (loadingUserPreferences || loadingVideoSettings) return null;

  return (
    <React.Fragment>
      <Button
        onClick={() => {
          openSettingModal();
        }}
      >
        <TextWithIcon icon="ygb-icon-settings" iconSize={'15px'}>
          <Trans
            id="videos_genres.settings_button"
            message={'Mina inställningar'}
          />
        </TextWithIcon>
      </Button>

      {/* Modal */}
      <SettingsModal
        videoSettings={videoSettingsData.videoSettings}
        handleSave={async variables => {
          // update reactive var -> reload taxonomies
          videoSettingsVar(variables);
          if (currentUser?.id) {
            // update user preferences...
            patchUser({
              variables,
            });
          }
          // close modal
          videoSettingsModalOpenVar(false);
        }}
        loading={patchingUser}
      />
    </React.Fragment>
  );
};

export default VideoSettings;
